import {
  FETCH_RECEIVEPAYMENT_REQUEST,
  FETCH_RECEIVEPAYMENT_SUCCESS,
  FETCH_RECEIVEPAYMENT_FAILURE,
} from "./receivePaymentDetailsTypes";

const initialState = {
  loading: false,
  receivePaymentDetails: [],
  error: "",
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_RECEIVEPAYMENT_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case FETCH_RECEIVEPAYMENT_SUCCESS:
      return {
        loading: false,
        receivePaymentDetails: action.payload,
        error: "",
      };
    case FETCH_RECEIVEPAYMENT_FAILURE:
      return {
        loading: false,
        receivePaymentDetails: [],
        error: action.payload,
      };
    default:
      return state;
  }
};

export default reducer;
